import { useParams, Link } from "react-router-dom";
import { useGetUserQuery } from "./usersApiSlice";
import EditUserForm from "./EditUserForm";
import useTitle from "../../hooks/useTitle";

export default function EditUser() {
  useTitle('App: Edit User')
  
  const { id } = useParams();
  const { data: user, isLoading, isFetching, isError, error } = useGetUserQuery(id);

  return (
    <div className="min-h-full px-4 sm:px-6 lg:px-8 py-6">
      {/* Page header (consistent across pages) */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">Edit User</h1>
          <p className="text-sm text-gray-500">Update account details, roles, and status.</p>
        </div>
        <Link
          to="/dash/users"
          className="rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          Back
        </Link>
      </div>

      {/* States */}
      {(isLoading || isFetching) && (
        <div className="mt-6 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <div className="h-5 w-36 bg-gray-100 rounded mb-4" />
          <div className="space-y-2">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-12 bg-gray-50 rounded-xl" />
            ))}
          </div>
        </div>
      )}

      {isError && (
        <div className="mt-6 rounded-xl border border-rose-200 bg-rose-50 p-3 text-rose-700">
          Failed to load user{error?.status ? ` (HTTP ${error.status})` : ""}.
        </div>
      )}

      {!isLoading && !isFetching && !isError && !user && (
        <div className="mt-6 rounded-2xl border border-gray-200 bg-white p-10 text-center text-gray-500 shadow-sm">
          User not found.
        </div>
      )}

      {/* Form card (only render when we have the user) */}
      {user && (
        <div className="mt-6">
          <EditUserForm user={user} />
        </div>
      )}
    </div>
  );
}
